import React, { useState, useEffect } from 'react';

const BACKEND_URL = '';

export function SponsorBanner({ placement = 'app', type = 'top', className = '' }) {
  const [banners, setBanners] = useState([]);

  useEffect(() => {
    fetch(`${BACKEND_URL}/api/banners?placement=${placement}`, { credentials: 'include' })
      .then(r => r.ok ? r.json() : [])
      .then(data => setBanners(Array.isArray(data) ? data.filter(b => b.banner_type === type) : []))
      .catch(() => {});
  }, [placement, type]);

  if (banners.length === 0) return null;

  const banner = banners[0];

  // Fire tracking as a fire-and-forget call with `keepalive: true` so the
  // request survives the browser navigating away to the click_url. Doing
  // this synchronously inside the click handler (rather than awaiting it
  // before window.open) is what makes the click-through work on mobile —
  // mobile browsers strip the "user gesture" once you `await`, which gets
  // any subsequent window.open / navigation blocked as an unwanted popup.
  const trackClick = () => {
    try {
      fetch(`${BACKEND_URL}/api/banners/${banner.banner_id}/click`, {
        method: 'POST',
        credentials: 'include',
        keepalive: true,
      }).catch(() => {});
    } catch {}
  };

  // Top and footer share the same wide-banner shape per Feb 2026 spec —
  // the only thing that changes is which slot on the page they render
  // into. Side stays narrower for the right rail.
  const sizeClasses = type === 'side'
    ? 'w-full max-w-[600px] max-h-[375px]'
    : 'w-full max-h-[135px]';

  const imageEl = (
    <img
      src={banner.image_url}
      alt="Sponsor"
      className={`${sizeClasses} object-contain rounded`}
      loading="lazy"
    />
  );

  return (
    <div
      data-testid={`sponsor-banner-${type}-${placement}`}
      className={className}
    >
      <div className="text-center">
        <p className="text-[10px] text-slate-400 mb-0.5">Sponsored</p>
        {banner.click_url ? (
          <a
            href={banner.click_url}
            target="_blank"
            rel="noopener noreferrer sponsored"
            onClick={trackClick}
            onAuxClick={trackClick}
            className="cursor-pointer transition-opacity hover:opacity-90 inline-block"
            data-testid={`sponsor-banner-link-${type}`}
          >
            {imageEl}
          </a>
        ) : (
          <div className="inline-block">{imageEl}</div>
        )}
      </div>
    </div>
  );
}
